{
    "ServerStatus_heading_applicationProperties": "Toepassingseigenschappen",
    "ServerStatus_action_refresh": "Vernieuw status",
    "NAME": "ServerStatusTaal"
}